<app-filterable-table
  #chargebacksTable
  [tableView]="tableView"
  [options]="tableOptions"
></app-filterable-table>
